import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';

import { getIconByKey, IconToken } from '@1debit/icons';
import { pascalToSnake } from 'utils/formatters';
import { SocialMediaClassNames, SocialMediaItemProps, SocialMediaVariantProps } from './types';
import Media from 'components/shared/Media/Media';
import Button from 'components/shared/Buttons/BaseButton';
import { cn } from 'utils/styles';
import { liveUpdateAttrs } from 'libs/contentful/utils';

const SocialMediaItem = ({ social, className }: SocialMediaItemProps) => {
  const realIconName = pascalToSnake(social?.iconName ?? '');

  const Icon = getIconByKey(realIconName as IconToken);

  const internalClassNames = {
    wrapper: cn(
      'min-w-60 grid grid-cols-[2.5rem_1fr] grid-rows-[min_content] gap-2 justify-items-start',
      className?.wrapper,
    ),
    icon: cn('rounded-none justify-self-center self-center h-fit', className?.icon),
    label: cn('font-sans font-semibold leading-none self-center h-fit', className?.label),
  };

  const iconElement = Icon ? (
    <Icon className={internalClassNames.icon} />
  ) : social.icon ? (
    <Media media={social.icon} className={internalClassNames.icon} />
  ) : null;

  return (
    <Button href={social.url} className={internalClassNames.wrapper}>
      {iconElement}
      <span className={internalClassNames.label} data-testid="social-item-label">
        {social.label}
      </span>
    </Button>
  );
};

const SocialMediaVariant = ({ sys, headline, socialMedia, className }: SocialMediaVariantProps) => {
  const internalClassNames: SocialMediaClassNames = {
    wrapper: cn('flex flex-col gap-6 sm:grid sm:grid-cols-2 sm:justify-between', className?.wrapper),
    headline: cn('text-heading-md sm:text-heading-lg-fixed font-sans', className?.headline),
    socials: {
      wrapper: cn('sm:mx-auto', className?.socials?.wrapper),
      list: cn('flex flex-col gap-2', className?.socials?.list),
    },
  };

  return (
    <div className={internalClassNames.wrapper}>
      <div className={internalClassNames.headline} {...liveUpdateAttrs(sys?.id, 'headline')}>
        <RichTextHeadline headline={headline} level="h2" />
      </div>

      <div className={internalClassNames.socials.wrapper}>
        <div className={internalClassNames.socials.list}>
          {(socialMedia?.items ?? []).map(social => (
            <div key={social.sys?.id} {...liveUpdateAttrs(sys?.id, 'linkedIcon')}>
              <SocialMediaItem social={social} className={className?.socials?.item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SocialMediaVariant;
